var Brand = {

	jsonPath: 'data/brands/',

	brands: [],
	properties: {},

	brand: '',

	setConfig: function(brands, currentBrand) {
		this.brands = brands;

		if (brands[currentBrand]) {
			this.setBrand(currentBrand);
		} else {
			console.error('The current brand of the configuration is not in brands list', brands);
		}
	},

	load: function() {
		return $.getJSON(this.jsonPath + this.brands[this.brand], (function(json) {
			this.properties = json;
		}).bind(this)).fail(function() {
			console.error('Error loading the corresponding brand json');
		});
	},

	init: function() {
		console.log("init brandjs",this.properties);
		$.each(this.properties, function (cssPropertyName, properties) {

			$.each(properties, function(classSelector, value) {

				var $elements = $('.' + classSelector);

				if ($elements.length === 0) {
					return
				}

				if (classSelector.indexOf('hover') === -1) {

					$elements.css(cssPropertyName, value);

				} else {

					var tagName = $elements.prop('tagName').toLowerCase();

					// Apply hover interaction style with js
					var $elementsHover = $elements.parent().find(tagName + '.' + classSelector + ':not(.js-no-hover)');
					var noHoverValue = Brand.properties[cssPropertyName][classSelector.split('-hover')[0]] ? Brand.properties[cssPropertyName][classSelector.split('-hover')[0]] : $elementsHover.css(cssPropertyName, $elementsHover.css(cssPropertyName));



					// Bind mouse enter and mouse leave interaction to simulate :hover css
					$elementsHover.hover(function (evt) {
						$(evt.currentTarget).css(cssPropertyName, value);
					}, function (evt) {
						console.log("mouseleave", cssPropertyName);
						$(evt.currentTarget).css(cssPropertyName, noHoverValue);
					});

					// Apply static hover style
					$elementsNoHover = $elements.parent().find(tagName + '.' + classSelector + '.js-no-hover');
					$elementsNoHover.css(cssPropertyName, value);
				}
			});
		});
	},

	setBrand: function(brand) {

		if (this.brands[brand]) {
			this.brand = brand;
		} else {
			console.error('You are setting an unknown brand code', brand, this.brands);
		}
	},

	changeBrand: function(brand) {
		this.setBrand(brand);

		$.when(this.load()).done((function() {
			this.init();
		}).bind(this));
	},
}
